// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-layout{height:100%;position:relative}.default-layout .default-layout__main{min-height:100%}.default-layout .default-layout__view{margin-top:105px}.default-layout .default-layout__portal-bottom{position:sticky;bottom:0;left:0;right:0;z-index:6}.default-layout .default-layout__portal-right{position:fixed;z-index:9;top:0;bottom:0;right:0}", ""]);
// Exports
module.exports = exports;
